export default function (context) {

	$(context).find('input[data-mask]').each((key, node) => {
		let maskOptions = {
			mask: node.getAttribute('data-mask')
		};
		const { IMask } = window;

		if (IMask)
			new IMask(node, maskOptions);
	});
};
